import React from 'react';

import BaseComponent from "../baseComponent.js";
import DashboardService from "../../core/services/dashboardService.js";
import Grid from "./grid/grid.jsx";
import WidgetType from "../../core/constants/widgetType";
import {variableTypes} from "../../components/dashboard/control-widget/selection-contorl/constants";

import styles from "./styles.scss";
import "!style!css!../../vendors/gridster/gridster.css";
import InternalEventBus from "../../core/utils/internalEventBus";
import InternalEvent from "../../core/constants/internalEvent";
import AppService from '../../core/services/app-service';

import {fromEvent} from 'rxjs/observable/fromEvent';
import {throttleTime, map} from 'rxjs/operators';

export default class DashboardStandAlone extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      dashboard: null
    };
    this.resizeTimeout = null;
    AppService.isStandAloneApp = true;
    fromEvent(window, 'resize')
      .pipe(
        throttleTime(300),
        map(_ => AppService.setDisplaySize(window.innerWidth))
      ).subscribe();
    console.log('DashboardStandAlone')
  }

  componentDidMount() {
    console.log('DashboardStandAlone componentDidMount')
    Promise.all([this.resolveDependencies(), this.authenticate()])
      .then(([response, authorized]) => {
        console.log('DashboardStandAlone componentDidMount Promise.all resolved')
        $("#loading").hide();
        if (authorized) {
          window.parent.postMessage("getParams", "*");
          this.handleMessages();
          this.handleResize();
        } else {
          console.log(`[Standalone dashboard] Unauthorized.`);
          this.setState({
            authorized: false
          });
        }
      });
  }

  handleContainerClick(e) {
    this.publish(InternalEvent.App.DOCUMENT_CLICKED, e.target);
  }

  handleResize() {
    window.addEventListener("resize", e => {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout(() => {
        const newDimension = this.calcNewGridBaseDimension(this.gridModels, DashboardService.activeDashboard.variables);
        this.refs.grid.resizeAllWidgets(newDimension);
        InternalEventBus.publish(InternalEvent.Dashboard.STANDALONE_DASHBOARD_RESIZED);
      }, 300)
    });
  }

  handleMessages() {
    window.addEventListener("message", message => {
      const data = JSON.parse(message.data);
      console.log(`[Standalone dashboard] Authorized. Loading dashboard now....`);
      DashboardService.findDashboardById(this.getDashboardId())
        .then(dashboard => {
          DashboardService.activeDashboard = dashboard;
          DashboardService.activeDashboard.dashboardState = dashboard.state.dashboardState;
          return DashboardService.checkSharedDashboardForUpdate(dashboard);
        })

        .then(newState => {
          const activeDashboard = DashboardService.activeDashboard
          if (newState) {
            // state updated
            activeDashboard.state.dashboardState = newState;
          }
          // need to store grid models in order to handle resizing
          const widgetModels = activeDashboard.state.dashboardState.map(s => s.widgetModel);
          this.gridModels = activeDashboard.state.dashboardState.map(s => s.gridsterModel);
          this.overwriteDashboardVariablesFromSelection(data, activeDashboard.variables, widgetModels)
          this.overwriteDashboardVariables(data, activeDashboard.variables, this.gridModels);
          this.setState({
            dashboard: activeDashboard
          });
        });
    });
  }

  overwriteDashboardVariablesFromSelection(urlParams, dashboardVariables, widgetModels) {
    // find selection from selection control widgets
    const controlWidgets = widgetModels.filter(m => m.type === WidgetType.CONTROL_WIDGET);
    const selectionControls = controlWidgets.filter(w => w.metaData.type === 'selection');
    Object.keys(urlParams).forEach(key => {
      const value = urlParams[key];
      // key of urlParams === title of selection control
      const matchedSelectionControl = selectionControls.find(s => s.metaData.title === key);

      if (matchedSelectionControl) {
        // value of urlParam === description of selection option
        const selection = matchedSelectionControl.metaData.selections.find(s => s.description === value);
        if (selection) {
          selection.variables.forEach(v => {
            const dv = dashboardVariables[v.id];
            if (dv) {
              switch (dv.type) {
                case variableTypes.EXPRESSION:
                  dv.expression = v.expression;
                  break;
                default:
                  dv.value = v.value;
              }
            }
          });
          // change selection
          matchedSelectionControl.metaData.currentSelectionId = selection.id;

          // no further process required for this param
          delete urlParams[key];
        }
      }
    })
  }

  overwriteDashboardVariables(data, dashboardVariables, gridModels) {
    for (let variableName in data) {
      if (data[variableName] != null) {
        this._overWriteVariableValue(dashboardVariables, variableName, data[variableName]);
      }
    }
    this.calcNewGridBaseDimension(gridModels, dashboardVariables);
    DashboardService.evaluateDashboardVariables(dashboardVariables);
  }

  _overWriteVariableValue(dashboardVariables, targetVariableName, value) {
    let updated = false;
    let datasetControlValueVariable = null;
    for (let prop in dashboardVariables) {
      if (dashboardVariables[prop].name === targetVariableName) {
        dashboardVariables[prop].value = value;
        updated = true;
      }

      // find datasetControl variable
      if (targetVariableName + "DatasetId" === dashboardVariables[prop].name) {
        datasetControlValueVariable = dashboardVariables[prop];
      }
    }

    // update datasetControl variable if nothing has been updated
    if (!updated && datasetControlValueVariable) {
      datasetControlValueVariable.value = value;
    }
  }

  getBodyDimension() {
    const body = document.getElementsByTagName("body")[0];
    return {
      width: body.clientWidth,
      height: body.clientHeight
    }
  }

  calcNewGridBaseDimension(gridModels, dashboardVariables) {
    const dimension = this.getBodyDimension();
    let maxX = 0, maxY = 0;
    gridModels.forEach(m => {
      var [x, y, r, c] = [m.size_x, m.size_y, m.row, m.col];

      if (x + c > maxX) {
        maxX = x + c - 1;
      }
      if (y + r > maxY) {
        maxY = y + r - 1;
      }
    });

    const newDimension = {
      width: dimension.width / maxX,
      height: dimension.height / maxY
    };

    if (dashboardVariables) {
      dashboardVariables.gridBaseDimensions = {
        id: "gridBaseDimensions",
        value: newDimension
      };
    }

    return newDimension;
  }

  authenticate() {
    return new Promise((resolve) => {
      const authToken = this.getUrlParameter("authToken");
      if (authToken) {
        console.log(`[Standalone dashboard] Found auth token ${authToken}`);
        console.log(`[Standalone dashboard] Connecting to solace using auth token....`);
        console.time('login');
        smashClient.login(authToken, "apikey", (response) => {
          console.log('smashClient.login')
          resolve(true);
        });
      } else {
        smashClient.login("bill.jh.kim@gmail.com", "1234", (response) => {
          resolve(true);
        });
      }
    });
  }

  getDashboardId() {
    const pos = window.location.href.indexOf("/d#");
    const startIndex = pos + 3;
    return window.location.href.substring(startIndex, startIndex + 36);
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]').toUpperCase();
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.href.toUpperCase());
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  resolveDependencies() {
    return new Promise((resolve, reject) => {
      try {
        require.ensure([], require => {
          // require('../../../src-epoch/epoch-0.6.0.js');
          require('../../vendors/jsep/jsep.js');
          require('../../vendors/gridster/gridster-0.5.6.js');
          // require("../../vendors/jquery-mousewheel/jquery.mousewheel.js");
          console.log('resolveDependencies')
          resolve();
        });
      }
      catch (err) {
        reject(err);
      }
    });
  }

  handleDashboardVariableUpdate(variables) {
    const variablesCopy = JSON.parse(JSON.stringify(DashboardService.getCurrentDashboardVariables()));
    variables.forEach(v => {
      variablesCopy[v.id] = v;
    });
    return this.updateActiveDashboard(variablesCopy);
  }

  updateActiveDashboard(dashboardVariable) {
    const copy = JSON.parse(JSON.stringify(DashboardService.activeDashboard));
    copy.variables = dashboardVariable;

    DashboardService.evaluateDashboardVariables(copy.variables);

    this.dashboardVariables = copy.variables;
    return DashboardService.updateDashboard(copy, copy);
  }

  saveDashboardState(dashboardStateId, dashboardState) {
    this.showPreloader();
    DashboardService.updateDashboardState(DashboardService.activeDashboard.persistenceId, dashboardStateId, dashboardState);
  }

  render() {
    if (this.state.authorized === false) {
      return <div>Unauthorized</div>;
    } else {
      return (
        <div className={styles.dashboardContainer} style={{overflow: 'hidden', margin: 0}} onClick={this.handleContainerClick}>
          {
            this.state.dashboard ?
              <Grid dashboardState={this.state.dashboard.state} ref="grid"
                    isStandAloneDashboard={true}
                    router={this.props.router}
                    onVariableUpdated={this.handleDashboardVariableUpdate}
                    updateDashboardVariable={() => {
                      return Promise.resolve();
                    }}
                    onResizeAll={() => {
                    }}
                    onWidgetChange={(id, state) => this.saveDashboardState(id, state)}/>
              : null
          }
          <div id="tooltips-container">
          </div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardStandalon.jsx